import "./TableEdit.scss";
import {
  Col,
  Row,
  Radio,
  Form
} from "antd";

import { useTranslation } from "react-i18next";
import { FieldSetEdit, ParagraphEdit } from '..'

const TableEdit = ({ form, section, component, fieldset, lang, handleChangeValuesSection, isRiskGuideDemo=false }) => {
	const { t } = useTranslation('forms')

  return (
    <div className="form-manager-comp-table-edit">
    { component.type === 'TABLE' &&
      <Row style={{marginBottom: '10px'}}>
        <Col span={24}>
          <Form.Item label={t('forms.manager.tableEdit.sectionText')}>
              <ParagraphEdit form={form} section={section} component={component} lang={lang} handleChangeValuesSection={handleChangeValuesSection} />
          </Form.Item>
        </Col>
      </Row>
    }
    { component.type === 'DECL' &&
      <Row>
        <Col span={21}>
          <Form.Item label={t('forms.manager.tableEdit.declarationQuestionText')}>
            <ParagraphEdit form={form} section={section} component={component} lang={lang} handleChangeValuesSection={handleChangeValuesSection} />
          </Form.Item>
        </Col>
        <Col span={2} offset={1}>
          <Form.Item label={t('forms.manager.tableEdit.decision')}>
            <Radio.Group disabled>
              <Radio className="radio-switch" value={true}>
                {t('forms.manager.tableEdit.yes')}
              </Radio>
              <Radio className="radio-switch" value={false}>
                {t('forms.manager.tableEdit.no')}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
    }
    { fieldset && <FieldSetEdit form={form} section={section} component={component} fieldset={fieldset} lang={lang} handleChangeValuesSection={handleChangeValuesSection} isRiskGuideDemo={isRiskGuideDemo} /> }
    </div>
  )
}
export default TableEdit;
